import React, { ChangeEvent, useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Alert,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import AuthLayout from "./authLayout";
import useAuth from "../../hooks/useAuth";
import { useAppDispatch } from "../../store/hooks";
import { loginSuccess } from "../../store/auth/slice";

const Signin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const { signIn } = useAuth();
  const dispatch = useAppDispatch();


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setError(""); // エラーメッセージをクリア
  };

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
    setError(""); // エラーメッセージをクリア
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    try {
      const signInData = {
        formData: {
          username: email,
          password: password,
        }
      };

      const response = await signIn(signInData);

      if (response) {
        dispatch(loginSuccess(response.account_data));
        navigate(PATHS.REPORT_AIRCON_LIST);
      }
    } catch (err: any) {
      if (err.type === 'UnauthorizedRoleError') {
        setError('このアカウントには管理者権限がありません。管理者アカウントでログインしてください。');
      } else {
        setError('メールアドレスまたはパスワードが正しくありません');
        // setError(err.message || 'メールアドレスまたはパスワードが正しくありません');
      }
    }
  };







  return (
    <AuthLayout>
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 2,
          display: "flex",
          flexDirection: "column",
          maxWidth: "450px",
          width: "100%",
        }}
      >
        <Box
          width={"100%"}
          paddingInline={2}
          display={"flex"}
          flexDirection={"column"}
          gap={1}
        >
          <Typography variant="h5" paddingBlock={2} align="center">
            ログイン
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              <TextField
                fullWidth
                value={email}
                type="text"
                onChange={handleEmailChange}
                label="メールアドレス"
              />
              <TextField
                type={showPassword ? "text" : "password"}
                fullWidth
                onChange={handlePasswordChange}
                label="パスワード"
                value={password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                sx={{ height: "42px" }}
                type="submit"
                variant="contained"
                fullWidth
              >
                ログイン
              </Button>
            </Box>
          </form>
          {/* <Box
            marginTop={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <Button
              variant="text"
              onClick={() => navigate(PATHS.AUTH_PASSWORD_FORGET)}
            >
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "rgba(9, 69, 88, 0.4)",
                }}
              >
                パスワードをお忘れですか？
              </Typography>
            </Button>
            <Button variant="text" onClick={() => navigate(PATHS.AUTH_SIGN_UP)}>
              <Typography
                variant="body2"
                sx={{
                  textDecoration: "underline",
                  textDecorationColor: "rgba(9, 69, 88, 0.4)",
                }}
              >
                まだアカウントをお持ちでない方はこちら
              </Typography>
            </Button>
          </Box> */}
        </Box>
      </Card>
    </AuthLayout>
  );
};

export default Signin;